import { useQuery } from '@tanstack/react-query';
import { QueryKey } from '@shared/config';
import { companyReviewApi } from '../companyReviewApi';
import type { GetCompanyReviewsRequest } from '../types';

export const useGetCompanyReviews = (
  params: GetCompanyReviewsRequest,
  enabled = true
) => {
  return useQuery({
    queryKey: [QueryKey.GET_COMPANY_REVIEWS, params],
    queryFn: () => companyReviewApi.getCompanyReviews(params),
    enabled,
    retry: false,
  });
};
